import { interpretConnections } from "./projectConnectionsModel.js";

// This projection is list-only: module/compact consumers retain their own entries.
export const PORTFOLIO_LINK_KINDS = [
  { kind: "office", sourceKind: "location", title: "Office", icon: "places", missingLabel: "No office linked" },
  { kind: "lease", sourceKind: "lease", title: "Lease", icon: "leases", missingLabel: "No lease linked" },
  { kind: "slack", sourceKind: "slack", title: "Slack", icon: "slack", missingLabel: "No Slack channel linked" },
];
export const PORTFOLIO_SLOT_SIZE = 25;
export const PORTFOLIO_SLOT_GAP = 6;
export const PORTFOLIO_LINK_PADDING = 14;
export function portfolioLinksWidth(count = PORTFOLIO_LINK_KINDS.length) {
  return count * PORTFOLIO_SLOT_SIZE + Math.max(0, count - 1) * PORTFOLIO_SLOT_GAP + 2 * PORTFOLIO_LINK_PADDING;
}

export function portfolioLinkSlots(connections) {
  const { entries } = interpretConnections(connections);
  return PORTFOLIO_LINK_KINDS.map(definition => {
    const entry = entries.find(candidate => candidate.kind === definition.sourceKind);
    return {
      ...definition,
      href: entry?.href || null,
      label: entry?.href
        ? `Open ${definition.title}: ${entry.label}${entry.external ? " (opens in a new tab)" : ""}`
        : definition.missingLabel,
      external: Boolean(entry?.href && entry.external),
    };
  });
}
